import React from 'react';

const CodeOfConductPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-6 py-12 sm:py-16 text-center">
          <h1 className="text-4xl font-bold mb-4">Code of Conduct</h1>
          <p className="text-xl opacity-90">
            Our commitment to creating a safe and respectful environment for all attendees
          </p>
        </div>

        {/* Main Content */}
        <div className="px-6 py-8 sm:px-10">
          <div className="prose max-w-none">
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Pledge</h2>
              <p className="text-gray-700 mb-6">
                In the interest of fostering an open and welcoming environment, we as conference organizers pledge to make participation in our events and our community a harassment-free experience for everyone, regardless of age, body size, disability, ethnicity, gender identity and expression, level of experience, nationality, personal appearance, race, religion, or sexual identity and orientation.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Standards</h2>
              <p className="text-gray-700 mb-4">Examples of behavior that contributes to creating a positive environment include:</p>
              <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
                <li>Using welcoming and inclusive language</li>
                <li>Being respectful of differing viewpoints and experiences</li>
                <li>Gracefully accepting constructive criticism</li>
                <li>Focusing on what is best for the community</li>
                <li>Showing empathy towards other community members</li>
              </ul>
              
              <p className="text-gray-700 mb-4">Examples of unacceptable behavior by participants include:</p>
              <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
                <li>The use of sexualized language or imagery and unwelcome sexual attention or advances</li>
                <li>Trolling, insulting/derogatory comments, and personal or political attacks</li>
                <li>Public or private harassment</li>
                <li>Publishing others' private information, such as a physical or electronic address, without explicit permission</li>
                <li>Other conduct which could reasonably be considered inappropriate in a professional setting</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Responsibilities</h2>
              <p className="text-gray-700 mb-4">
                Conference organizers are responsible for clarifying the standards of acceptable behavior and are expected to take appropriate and fair corrective action in response to any instances of unacceptable behavior.
              </p>
              <p className="text-gray-700">
                Conference organizers have the right and responsibility to remove, edit, or reject comments, commits, code, wiki edits, issues, and other contributions that are not aligned to this Code of Conduct, or to ban temporarily or permanently any contributor for other behaviors that they deem inappropriate, threatening, offensive, or harmful.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Scope</h2>
              <p className="text-gray-700 mb-4">
                This Code of Conduct applies within all conference venues, including exhibition booths, and online communities and social media when an individual is representing the conference or its community. Examples of representing the conference or community include using an official conference e-mail address, posting via an official social media account, or acting as an appointed representative at an online or offline event.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Enforcement</h2>
              <p className="text-gray-700 mb-4">
                Instances of abusive, harassing, or otherwise unacceptable behavior may be reported by contacting the conference team at <a href="mailto:conduct@conferenceplanner2026.com" className="text-indigo-600 hover:underline">conduct@conferenceplanner2026.com</a>. All complaints will be reviewed and investigated and will result in a response that is deemed necessary and appropriate to the circumstances. The conference team is obligated to maintain confidentiality with regard to the reporter of an incident. Further details of specific enforcement policies may be posted separately.
              </p>
              <p className="text-gray-700">
                Conference organizers who do not follow or enforce the Code of Conduct in good faith may face temporary or permanent repercussions as determined by other members of the conference's leadership.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Attribution</h2>
              <p className="text-gray-700">
                This Code of Conduct is adapted from the <a href="https://www.contributor-covenant.org/" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">Contributor Covenant</a>, version 2.0, available at <a href="https://www.contributor-covenant.org/version/2/0/code_of_conduct/" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline break-all">https://www.contributor-covenant.org/version/2/0/code_of_conduct/</a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CodeOfConductPage;
